import { _callBackend } from '../api';
import type { Conversation } from '@/_types/models/conversations';
import type { APIRequest, APIResponsePromise } from '@/_types/api';

export const getV2Conversations = async ({
  token,
  perPage = 10,
  page = 0,
}: APIRequest<{ page?: number; perPage?: number }>): APIResponsePromise<
  Array<Conversation>
> =>
  await _callBackend(
    `/v2/conversations?per_page=${perPage}&page=${page}`,
    'GET',
    null,
    token,
  );

export const getV2ConversationsCount = async ({
  token,
}: APIRequest<{ count?: boolean }>): APIResponsePromise<{
  count: number;
  unread_count: number;
}> => await _callBackend('/v2/conversations?count=true', 'GET', null, token);

export const findConversations = async ({
  search,
  token,
}: APIRequest<{ search: string }>): APIResponsePromise<Array<Conversation>> =>
  await _callBackend(
    '/v2/conversations/find_conversations?search=' + encodeURIComponent(search),
    'GET',
    null,
    token,
  );
